import { render, staticRenderFns } from "./order-userbar.vue?vue&type=template&id=b38b7ef2&scoped=true"
import script from "./order-userbar.vue?vue&type=script&lang=js"
export * from "./order-userbar.vue?vue&type=script&lang=js"
import style0 from "./order-userbar.vue?vue&type=style&index=0&id=b38b7ef2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38b7ef2",
  null
  
)

export default component.exports